import Swiper from 'swiper/bundle';

export class Slider {
	constructor() {
		this.init();
	}

	init() {
		const sliderHomeContent = new Swiper('.slider-home-content', {
			spaceBetween: 100,
			slidesPerView: 3,
			breakpoints: {
				1280: {
					spaceBetween: 200,
				},
				1536: {
					spaceBetween: 250,
				}
			}
		});

		const sliderHome = new Swiper('.slider-home', {
			effect: 'fade',
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			speed: 700,
			simulateTouch: false,
			navigation: {
				nextEl: '.slider__button-next',
				prevEl: '.slider__button-prev',
			},
			thumbs: {
				swiper: sliderHomeContent,
			}
		});

		sliderHome.on('slideChange', function () {
			let progressIndicator = $('.slider-duration-indicator__inner');

			progressIndicator.removeClass('is-animated');

			setTimeout(() => {
				progressIndicator.addClass('is-animated');
			}, 50);
		});


		const infoCarousel = new Swiper('#infoCarousel', {
			slidesPerView: 2,
			watchOverflow: true,
			loop: true,
			breakpoints: {
				992: {
					slidesPerView: 3
				},
				1280: {
					slidesPerView: 4
				}
			},
			navigation: {
				prevEl: '#infoCarouselPrev',
				nextEl: '#infoCarouselNext'
			},
			pagination: {
				el: '#infoCarouselPagination',
				clickable: true,
				modifierClass: 'carousel-pagination-',
				bulletClass: 'carousel-pagination__bullet',
				bulletActiveClass: 'carousel-pagination__bullet--active'
			}
		});

		const tourismBoxCarouselEl = document.getElementById('tourismBoxCarousel');
		if (tourismBoxCarouselEl) {
			const tourismBoxCarousel = new Swiper(tourismBoxCarouselEl, {
				slidesPerView: 2,
				breakpoints: {
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4
					},
					1280: {
						slidesPerView: 5
					}
				},
				navigation: {
					prevEl: '#tourismBoxCarouselPrev',
					nextEl: '#tourismBoxCarouselNext'
				},
				pagination: {
					el: '#tourismBoxCarouselPagination',
					clickable: true,
					modifierClass: 'carousel-pagination-',
					bulletClass: 'carousel-pagination__bullet',
					bulletActiveClass: 'carousel-pagination__bullet--active'
				}
			});
		}
	}
}

export const eventsCarousel = new Swiper('#eventsCarousel', {
	slidesPerView: 2,
	breakpoints: {
		768: {
			slidesPerView: 3,
		},
		1024: {
			slidesPerView: 4
		},
		1280: {
			slidesPerView: 5
		}
	},
	navigation: {
		prevEl: '#eventsCarouselPrev',
		nextEl: '#eventsCarouselNext'
	},
	pagination: {
		el: '#eventsCarouselPagination',
		clickable: true,
		modifierClass: 'carousel-pagination-',
		bulletClass: 'carousel-pagination__bullet',
		bulletActiveClass: 'carousel-pagination__bullet--active'
	}
});

export const entryCardsCarousel = new Swiper('#newsCarousel', {
	slidesPerView: 2,
	breakpoints: {
		768: {
			slidesPerView: 3,
		},
		1024: {
			slidesPerView: 4
		},
		1280: {
			slidesPerView: 5
		}
	},
	navigation: {
		prevEl: '#cardsCarouselPrev',
		nextEl: '#cardsCarouselNext'
	},
	pagination: {
		el: '#cardsCarouselPagination',
		clickable: true,
		modifierClass: 'carousel-pagination-',
		bulletClass: 'carousel-pagination__bullet',
		bulletActiveClass: 'carousel-pagination__bullet--active'
	}
});

export const imprezyListaCarousal = function (id) {
	const eventsCarousel = new Swiper('#impc-' + id, {
		slidesPerView: 2,
		watchOverflow: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4
			},
			1280: {
				slidesPerView: 5
			}
		},
		navigation: {
			prevEl: '#impc-prev-' + id,
			nextEl: '#impc-next-' + id
		},
	});
	//console.log('::' + id);
}

const impListaCarousels = document.querySelectorAll('.kd-implista-carousal');
for (let i = 0; i < impListaCarousels.length; i++) {

	imprezyListaCarousal(impListaCarousels[i].getAttribute('data-id'));
}